import React from "react";
import { Link } from "react-router-dom";
import { Seo, SITE_URL } from "@/components/Seo";
import { Breadcrumbs, crumbLd } from "@/components/Breadcrumbs";
import { GUIDES } from "@/lib/guides";
import { BookOpen, ArrowRight } from "lucide-react";

export default function Guides() {
  const crumbs = [{ name: "Home", to: "/" }, { name: "Guides" }];
  return (
    <div className="px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto py-10" data-testid="guides-index">
      <Seo
        title="Property & Land Buying Guides for Telangana | Dotlands Realty"
        description="Practical guides on buying agricultural land and plots in Telangana — HMDA & DTCP approvals, property documents, registration and land investment near Hyderabad."
        path="/guides"
        jsonLd={crumbLd(crumbs)}
      />
      <Breadcrumbs items={crumbs} />
      <div className="max-w-2xl">
        <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#C8A24C]/15 text-[#A8863A] text-xs font-bold uppercase tracking-wide"><BookOpen className="w-3.5 h-3.5" /> Guides</span>
        <h1 className="text-3xl sm:text-4xl font-heading font-extrabold text-[#0E3B2E] mt-4">Property &amp; Land Buying Guides</h1>
        <p className="text-slate-600 mt-3">Clear, practical information to help you buy agricultural land and plots in Telangana with confidence.</p>
      </div>
      <div className="grid sm:grid-cols-2 gap-5 mt-8">
        {GUIDES.map((g) => (
          <Link key={g.slug} to={`/guides/${g.slug}`} data-testid={`guide-card-${g.slug}`}
            className="group bg-white border border-slate-200 rounded-2xl p-6 hover:border-[#C8A24C] hover:shadow-md transition-all">
            <h2 className="font-heading font-bold text-lg text-[#0E3B2E] group-hover:text-[#A8863A]">{g.h1}</h2>
            <p className="text-sm text-slate-600 mt-2 leading-relaxed">{g.excerpt}</p>
            <span className="inline-flex items-center gap-1 text-sm font-semibold text-emerald-700 mt-4">Read guide <ArrowRight className="w-4 h-4" /></span>
          </Link>
        ))}
      </div>
    </div>
  );
}
